<template>
  <div style="display: flex; align-items: center; background: #fff">
    <div style="height: 40px; display: flex; align-items: center">
      <img src="../../assets/logo.png" style="height: 26px" />
      <span style="color: #000000; font-weight: 600; font-size: 18px; display: inline-block; margin: 0 30px 0 7px">投放系统</span>
    </div>
    <el-menu :default-active="activeIndex" mode="horizontal" class="side-menu" @select="handleSelect">
      <template v-for="item in menus">
        <el-menu-item :key="item.menuId" v-if="item.children.length == 0" :index="item.menuAdr || item.menuId + ''">{{
          item.menuName
        }}</el-menu-item>
        <el-submenu :key="item.menuId" v-else :index="item.menuId + ''">
          <template slot="title">{{ item.menuName }}</template>
          <div class="sub-wrap">
            <div v-for="secondItem of item.children" :key="secondItem.menuId" class="second-menu">
              <div class="second-title">
                <svg-icon :iconClass="secondItem.icon" className="menu-icon"></svg-icon>
                <span class="title-text">{{ secondItem.menuName }}</span>
              </div>
              <div class="item-list">
                <el-menu-item class="sub-item" v-for="item of secondItem.children" :key="item.menuId" :index="item.menuAdr">{{
                  item.menuName
                }}</el-menu-item>
              </div>
            </div>
          </div>
        </el-submenu>
      </template>
    </el-menu>
  </div>
</template>

<script>
import { sortArr } from "../../utils/tool";
// import router from "../../router";
import SvgIcon from "../../components/SvgIcon.vue";
export default {
  name: "SideMenu",
  data() {
    return {
      // activeIndex: this.$router.history.current.path.slice(1),
      activeIndex: "1",
    };
  },
  computed: {
    menus: function () {
      return sortArr(this.$store.state.login.menu);
      // return sortArr();
    },
  },
  components: { SvgIcon },
  mounted() {
    this.$nextTick(() => {
      let curRouter = this.$router.currentRoute.path;
      this.activeIndex = curRouter.replace(/^\//g, "");
    });
  },
  watch: {
    $route: {
      handler(val) {
        this.activeIndex = val.path.slice(1);
      },
      deep: true,
    },
  },
  methods: {
    handleSelect(key) {
      this.activeIndex = key;
      this.$router.push({ path: `/${key}` });
    },
    // handleRoute(parentNode, currentNode) {
    //   console.log(parentNode, currentNode);
    //   localStorage.setItem("secendRoute", JSON.stringify(parentNode));
    //   localStorage.setItem("currentMenu", JSON.stringify(currentNode));
    //   router.push({ path: `/${currentNode.menuAdr}` });
    // },
  },
};
</script>

<style lang="less" scoped>
.side-menu {
  display: flex;
  align-items: center;
  height: 40px;
  border-bottom: none;
  /deep/ .el-menu-item {
    height: 40px;
    line-height: 40px;
    font-size: 15px;
    color: rgba(0, 0, 0, 0.85);
    position: relative;
    margin: 0 10px;
    &:hover {
      color: rgba(24, 144, 255, 1);
    }
    &.is-active {
      font-weight: bold;
      color: rgba(24, 144, 255, 1);
      border-bottom-color: transparent;
      &::after {
        content: "";
        width: 26px;
        height: 3px;
        background-color: rgba(24, 144, 255, 1);
        position: absolute;
        bottom: 0px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
  /deep/ .el-submenu {
    height: 40px;
    line-height: 40px;
    position: relative;
    margin: 0 10px;
    &.is-active {
      font-weight: bold;
      color: rgba(24, 144, 255, 1);
      border-bottom-color: transparent;
      .el-submenu__title {
        font-weight: bold;
        color: rgba(24, 144, 255, 1);
      }
      &::after {
        content: "";
        width: 26px;
        height: 3px;
        background-color: rgba(24, 144, 255, 1);
        position: absolute;
        bottom: 0px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    .el-submenu__title {
      height: 40px;
      line-height: 40px;
      font-size: 15px;
      color: rgba(0, 0, 0, 0.85);
      border-bottom-color: transparent;
      &:hover {
        color: rgba(24, 144, 255, 1);
      }
      .el-submenu__icon-arrow {
        display: none;
      }
    }
  }
}
.sub-wrap {
  padding: 10px 0;
  display: flex;
  .second-menu {
    width: 130px;
    padding-left: 10px;
    .second-title {
      padding-left: 8px;
      margin-bottom: 8px;
      .menu-icon {
        color: rgb(24, 144, 255);
        margin-right: 5px;
        font-size: 14px;
      }
      .title-text {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.65);
        font-weight: bold;
      }
    }
    .item-list {
      .sub-item {
        color: rgba(0, 0, 0, 0.85);
        &:hover {
          color: rgba(24, 144, 255, 1);
        }
      }
    }
  }
  .second-menu:not(:last-child) {
    border-right: 1px dashed rgba(0, 0, 0, 0.2);
  }
}
</style>
